import { render, staticRenderFns } from "./EditAttributeItem.vue?vue&type=template&id=71200984&scoped=true"
import script from "./EditAttributeItem.vue?vue&type=script&lang=js"
export * from "./EditAttributeItem.vue?vue&type=script&lang=js"
import style0 from "./EditAttributeItem.vue?vue&type=style&index=0&id=71200984&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71200984",
  null
  
)

export default component.exports